module.exports = __webpack_public_path__ + "static/media/404Image.5f2f0346.svg";